import { lazy } from 'react';

export const PlayerMarketingWebPushForm = lazy(
  () => import('./PlayerMarketingWebPushForm'),
);
